import { createAsyncThunk } from "@reduxjs/toolkit"

import { getApiErrorMessage, handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../services"
import { PERKS_SLICE_NAME } from "./perks.constants"

// The legacy saga dispatched its failure action with the resolved message string, which the
// reducer stored as `error` — so reject with the message rather than the raw response body.
export const getPerks = createAsyncThunk(
  `${PERKS_SLICE_NAME}/get_perks`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getPerks(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(await getApiErrorMessage(response))
    }
    return response.data
  }
)
